import { render, staticRenderFns } from "./ServiceCompensationTabRow.vue?vue&type=template&id=3ef4f890&scoped=true"
import script from "./ServiceCompensationTabRow.vue?vue&type=script&lang=js"
export * from "./ServiceCompensationTabRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4f890",
  null
  
)

export default component.exports